<app-lf-oam-block class="lf-block" *ngFor="let item of learningFlow" [learningFlow]="item" [locale]="locale" (click)="onlfClick(item)"></app-lf-oam-block>
